import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import UnselectedSteps from './UnselectedSteps';
import SelectedStep from './SelectedStep';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  stepNumberText: {
    marginTop: theme.spacing(1),
  },
  unselectedStepsBefore: {},
  unselectedStepsAfter: {},
});

function splitSteps(steps, selectedStepId) {
  return steps.reduce((acc, curr) => {
    if (curr.stepId === selectedStepId) {
      acc.selected = curr;
      return acc;
    }

    if (acc.selected !== null) {
      acc.after.push(curr);
      return acc;
    }

    acc.selectedStepNumber++;
    acc.before.push(curr);
    return acc;
  }, {
    selected: null,
    before: [],
    after: [],
    selectedStepNumber: 1,
  });
}

const StepIndicator = ({
  className,
  classes,
  steps,
  selectedStepId,
}) => {
  const {
    before,
    after,
    selected,
    selectedStepNumber,
  } = splitSteps(steps, selectedStepId);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.row}>
        <UnselectedSteps
          className={classes.unselectedStepsBefore}
          position={'before'}
          steps={before}
        />
        <SelectedStep
          step={selected}
        />
        <UnselectedSteps
          steps={after}
          position={'after'}
          className={classes.unselectedStepsAfter}
        />
      </Box>
      <Box className={classes.row}>
        {steps.length > 1 ? (
          <Typography
            className={classes.stepNumberText}
            variant={'body1'}
            color={'accentBlue19'}
          >
            {`${selectedStepNumber} OF ${steps.length}`}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

StepIndicator.defaultProps = {
  className: '',
};

StepIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedStepId: PropTypes.string.isRequired,
};

export default withStyles(styles)(StepIndicator);
